module.exports = __webpack_public_path__ + "static/media/xpg-roulette.d4b67782.png";